import { useCallback, useEffect, useState } from "react";

export type Theme = "dark" | "light";
const KEY = "voss-theme";

const initial = (): Theme => {
  if (typeof document === "undefined") return "dark";
  const stored = localStorage.getItem(KEY);
  if (stored === "dark" || stored === "light") return stored;
  if (typeof window.matchMedia !== "function") return "dark";
  return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
};

/** Theme state, persisted and reflected onto <html data-theme>. */
export function useTheme(): { theme: Theme; toggleTheme: () => void; setTheme: (t: Theme) => void } {
  const [theme, setThemeState] = useState<Theme>(initial);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem(KEY, theme);
  }, [theme]);

  const setTheme = useCallback((t: Theme) => setThemeState(t), []);
  const toggleTheme = useCallback(() => setThemeState((t) => (t === "dark" ? "light" : "dark")), []);
  return { theme, toggleTheme, setTheme };
}
